import { ComponentProps, ReactNode } from "react";

import cn from "@/helpers/classNames";
import { IntegrationLogoBox } from "@/integrations";

export const EndpointBadge = (
  props: {
    integrationId: string;
    children: ReactNode;
  } & ComponentProps<"div">,
) => {
  const { integrationId, children, ...divProps } = props;
  return (
    <span
      {...divProps}
      className={cn(
        "relative inline-flex items-baseline gap-1 truncate rounded bg-muted px-1 py-1 pl-7 text-xs font-semibold text-foreground/75",
        {
          "cursor-pointer bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600":
            divProps.onClick,
        },
        divProps.className,
      )}
    >
      <IntegrationLogoBox
        id={integrationId}
        size="xs"
        className="absolute left-1 top-1/2 h-5 w-5 -translate-y-1/2"
      />
      <span className="truncate">{children}</span>
    </span>
  );
};
